var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotAvailableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50951 19C14.7616 19 19.019 14.7469 19.019 9.5C19.019 4.25315 14.7616 0 9.50951 0C4.25741 0 0 4.25315 0 9.5C0 14.7469 4.25741 19 9.50951 19ZM8.08308 14.2414C8.08308 13.4178 8.70976 12.825 9.50095 12.825C10.3093 12.825 10.9359 13.4178 10.9359 14.2414C10.9359 15.0651 10.3093 15.675 9.50095 15.675C8.70976 15.675 8.08308 15.0651 8.08308 14.2414ZM8.72212 3.8C8.65796 3.80007 8.59448 3.8131 8.53549 3.83833C8.47651 3.86355 8.42325 3.90044 8.37891 3.94677C8.33458 3.99311 8.30009 4.04792 8.27752 4.10792C8.25495 4.16792 8.24477 4.23187 8.2476 4.2959L8.53859 10.9459C8.54398 11.0682 8.59645 11.1837 8.68504 11.2683C8.77363 11.353 8.8915 11.4001 9.01406 11.4H10.0059C10.1285 11.4001 10.2463 11.353 10.3349 11.2683C10.4235 11.1837 10.476 11.0682 10.4814 10.9459L10.7714 4.2959C10.7742 4.23179 10.764 4.16776 10.7414 4.1077C10.7188 4.04764 10.6842 3.99278 10.6398 3.94643C10.5953 3.90008 10.542 3.86322 10.4829 3.83805C10.4238 3.81288 10.3602 3.79994 10.2959 3.8H8.72212Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAvailableIcon);
export default __webpack_public_path__ + "static/media/notAvailableIcon.04670a0cba77cf22445b1e5e824cd0cb.svg";
export { ForwardRef as ReactComponent };